import { useNavigate } from 'react-router';

import { createRequiredContext } from 'src/context/createRequiredContext';

import type { AppCardData } from './types';

type AppCardContextValue = {
  data: AppCardData;
  onAddProtection?: () => void;
  onFinishSetup: () => void;
};

const [useAppCard, AppCardProvider] = createRequiredContext<AppCardContextValue>();

type AppCardProviderProps = React.PropsWithChildren<Pick<AppCardContextValue, 'data' | 'onAddProtection'>>;

const AppCardContextProvider = ({ data, onAddProtection, children }: AppCardProviderProps) => {
  const navigate = useNavigate();

  const onFinishSetup = () => navigate(`/applications/${data.appId}/setup`);
  const value = {
    data,
    onAddProtection,
    onFinishSetup,
  };

  return <AppCardProvider value={value}>{children}</AppCardProvider>;
};

export { useAppCard, AppCardContextProvider as AppCardProvider };
export type { AppCardContextValue };
